module.exports = __webpack_public_path__ + "img/male-avatar.22c96a1c.png";